<div ngbDropdown ngbDropdown display="dynamic" placement="bottom-end">
  <div slot="head">
    <button type="button" class="btn btn-link nav-link" id="notification-dropdown" ngbDropdownToggle>
      <i class="far fa-bell"></i>
      <span class="badge badge-warning navbar-badge">15</span>
    </button>
  </div>
  <div slot="body" ngbDropdownMenu aria-labelledby="notification-dropdown">
    <span ngbDropdownItem class="dropdown-item dropdown-header">15 Notifications</span>
    <div class="dropdown-divider"></div>

    <a ngbDropdownItem href="#" class="dropdown-item">
      <i class="fas fa-envelope mr-2"></i> 4 new messages
      <span class="float-right text-muted text-sm">3 mins</span>
    </a>
    <div class="dropdown-divider"></div>
    <a ngbDropdownItem href="#" class="dropdown-item">
      <i class="fas fa-users mr-2"></i> 8 friend requests
      <span class="float-right text-muted text-sm">12 hours</span>
    </a>
    <div class="dropdown-divider"></div>
    <a ngbDropdownItem href="#" class="dropdown-item">
      <i class="fas fa-file mr-2"></i> 3 new reports
      <span class="float-right text-muted text-sm">2 days</span>
    </a>
    <div class="dropdown-divider"></div>
    <a ngbDropdownItem href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
  </div>
</div>

<ng-template #notification>
  <a href="#" class="dropdown-item">
    <i class="fas fa-envelope mr-2"></i> 4 new messages
    <span class="float-right text-muted text-sm">3 mins</span>
  </a>
  <div class="dropdown-divider"></div>
</ng-template>
